import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { QuoterStateService } from './quoter-state.service';

@Injectable({ providedIn: 'root' })
export class QueryParamsPersistenceService {
  private readonly router = inject(Router);
  private readonly quoterState = inject(QuoterStateService);

  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.reinjectIfMissing(event.urlAfterRedirects));
  }

  private reinjectIfMissing(url: string): void {
    const tracked = this.trackedParams();
    if (Object.keys(tracked).length === 0) return;

    const current = this.router.parseUrl(url).queryParams;
    const isMissing = Object.entries(tracked).some(([key, value]) => current[key] !== value);
    if (!isMissing) return;

    // replaceUrl: true — no agrega una entrada nueva al historial, así el botón "atrás" no queda roto.
    void this.router.navigate([], {
      queryParams: tracked,
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  private trackedParams(): Record<string, string> {
    const { utmParams, advisorCodeParam } = this.quoterState.state();
    const params: Record<string, string> = {};

    if (utmParams.utmSource) params['utm_source'] = utmParams.utmSource;
    if (utmParams.utmMedium) params['utm_medium'] = utmParams.utmMedium;
    if (utmParams.utmCampaign) params['utm_campaign'] = utmParams.utmCampaign;
    if (utmParams.utmContent) params['utm_content'] = utmParams.utmContent;
    if (utmParams.utmTerm) params['utm_term'] = utmParams.utmTerm;
    if (advisorCodeParam) params['codigoAsesor'] = advisorCodeParam;

    return params;
  }
}
